/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditScorecardRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit-scorecard',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditScorecardRoute);
